import React, { useState } from 'react';
import { MenuIcon, SearchIcon, X } from 'lucide-react';
export const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-111">
      <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-112">
        <div className="flex items-center" data-id="element-113">
          <div className="flex items-center" data-id="element-114">
            <div className="h-8 w-8 bg-gray-900 rounded-md flex items-center justify-center mr-2" data-id="element-115">
              <span className="text-white font-bold text-sm" data-id="element-116">K</span>
            </div>
            <h1 className="font-bold text-xl" data-id="element-117">KODIFY</h1>
          </div>
        </div>
        <div className="flex items-center space-x-4" data-id="element-118">
          <button aria-label="Search" className="p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300" onClick={() => setShowSearch(!showSearch)} data-id="element-119">
            <SearchIcon size={20} data-id="element-120" />
          </button>
          <button aria-label="Menu" className="p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300" onClick={() => setShowMenu(!showMenu)} data-id="element-121">
            <MenuIcon size={20} data-id="element-122" />
          </button>
        </div>
      </div>
      {showSearch && <div className="border-t border-gray-200 p-4 bg-white" data-id="element-123">
          <div className="relative" data-id="element-124">
            <input type="text" placeholder="Search for coupons, brands..." className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-125" />
            <SearchIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-126" />
          </div>
        </div>}
      {showMenu && <div className="fixed inset-0 bg-white z-50 p-4" data-id="element-127">
          <div className="flex justify-end" data-id="element-128">
            <button aria-label="Close menu" className="p-2 rounded-full hover:bg-gray-100" onClick={() => setShowMenu(false)} data-id="element-129">
              <X size={24} data-id="element-130" />
            </button>
          </div>
          <nav className="mt-8" data-id="element-131">
            <ul className="space-y-6 text-lg" data-id="element-132">
              <li data-id="element-133">
                <a href="#about" className="block py-2 hover:text-blue-600" data-id="element-134">
                  About
                </a>
              </li>
              <li data-id="element-135">
                <a href="#faq" className="block py-2 hover:text-blue-600" data-id="element-136">
                  FAQ
                </a>
              </li>
              <li data-id="element-137">
                <a href="#contact" className="block py-2 hover:text-blue-600" data-id="element-138">
                  Contact
                </a>
              </li>
            </ul>
          </nav>
        </div>}
    </header>;
};